import { useEffect, useState, useRef } from "react";
import PageHeader from "src/components/PageHeader";
import Table from "src/components/Table";
import moment from 'jalali-moment';
import { getData } from "src/actions/getData";
import Modal from "src/components/Modal";
import ModalHeader from "src/components/Modal/ModalHeader";
import ModalBody from "src/components/Modal/ModalBody";
import ModalFooter from "src/components/Modal/ModalFooter";
import TwinButton from "src/components/TwinButton";
import Inbound from "../SellerManagement/components/Inbound";
import { get, post } from "src/services/HttpClient";
import { notify } from "src/services/Notification/Notification";

export default function SubmitRefund() {
    const [data, setData] = useState();
    const [selectedRefund, setSelectedRefund] = useState();
    const [selectedSeller, setSelectedSeller] = useState(null);
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);


    const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
    const [refundProducts, setRefundProducts] = useState();
    const [warehouserComment, setWarehouserComment] = useState("");
    const [userComment, setUserComment] = useState("");
    const isInitialLoad = useRef(true);

    useEffect(() => {
        getUsers();
    }, []);

    useEffect(() => {
        if (selectedSeller) {
            // پاک کردن اطلاعات قبلی و دریافت اطلاعات جدید
            setData(undefined);
            fetchSellerInboundProducts(selectedSeller.id);
        }
    }, [selectedSeller]);

    const fetchSellerInboundProducts = async (sellerId) => {
        try {
            setLoading(true);
            const response = await get(`/inbounds/deliveredProducts/${sellerId}`);

            if (response?.success) {
                setData(response.body);
            }
        } catch (err) {
            console.error("Error fetching seller inboundProducts:", err);
        } finally {
            setLoading(false);
        }
    };

    const getUsers = async () => {
        try {
            const result = await get("/users");
            if (result?.success) {
                // فیلتر کردن فقط کاربران با نقش seller
                const sellers = result.body.filter(user => user.role?.role === "seller");
                setUsers(sellers);

                // اگر سلر وجود دارد، اولین مورد را انتخاب کن
                if (sellers.length > 0) {
                    setSelectedSeller(sellers[0]);
                }
            }
        } catch (err) {
            console.error("Error fetching users:", err);
        }
    };

    useEffect(() => {
        const controller = new AbortController(); // برای لغو درخواست
        const signal = controller.signal;

        getData(setData, "/inbounds/deliveredProducts", {}, signal);

        return () => {
            controller.abort();
        };
    }, []);

    useEffect(() => {
        if (selectedRefund && selectedRefund?.rows && selectedRefund?.rows.length) {
            setRefundProducts(selectedRefund.rows.map((row) => ({
                ...row.original,
                delivaryQuantity: row.original.deliveredQuantity ?? 0
            })));
        } else {
            setRefundProducts(null);
        }
    }, [selectedRefund]);

    useEffect(() => {
        if (!refundProducts || !isInitialLoad.current) return;

        const deficitTexts = refundProducts
            .map(item => {
                const totalQty = item.deliveredQuantity ?? 0;
                const refunded = item.delivaryQuantity ?? 0;
                const deficit = totalQty - refunded;
                if (deficit > 0) {
                    return `محصول ${item.name} (${item.sku}) به تعداد ${deficit} عدد کسری دارد.`;
                }
                return null;
            })
            .filter(Boolean);

        const newComment = deficitTexts.join(" ");
        setWarehouserComment(newComment);
        isInitialLoad.current = false;
    }, [refundProducts]);

    const submitRefund = async () => {
        try {
            const finalComment = warehouserComment + (userComment ? userComment : "");
            const payload = {
                warehouseComment: finalComment,
                products: refundProducts.map(item => ({
                    productId: item.productId,
                    name: item.name,
                    image: item.image,
                    sku: item.sku,
                    orderId: item.orderId,
                    // deliveredQuantity: item.deliveredQuantity,
                    refundQuantity: item.delivaryQuantity
                }))
            };

            setIsRefundModalOpen(false);

            const result = await post(`/seller/refunds/${selectedSeller.id}`, payload);

            if (result && result.success) {
                notify("مرجوعی با موفقیت ثبت شد", "success");
                setIsRefundModalOpen(false);
                setSelectedRefund(null);
                setWarehouserComment("");
                setUserComment("");
                isInitialLoad.current = true;
            } else {
                notify(result?.message || "خطا در ثبت مرجوعی", "error");
            }
        } catch (error) {
            notify("خطا در ارتباط با سرور", "error");
        }
    };

    const columns = [
        {
            id: "image",
            cell: (info) => (<img className="w-[80px] max-w-[80px] rounded-lg" src={info.getValue()} />),
            header: "تصویر",
        },
        {
            id: "name",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "نام محصول",
        },
        {
            id: "sku",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "SKU",
        },
        {
            id: "orderId",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "شماره سفارش",
        },
        {
            id: "supplier",
            cell: (info) => {
                const inbound = info.row.original.inbound;
                return inbound?.user?.fullName || "---";
            },
            header: "تامین کننده",
        },
        {
            id: "deliveredQuantity",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "تعداد تحویل شده",
        },
        {
            id: "deliveryDate",
            cell: (info) => {
                const inbound = info.row.original.inbound;
                if (inbound?.deliveredAt) {
                    return moment
                        .from(inbound.deliveredAt)
                        .locale("fa")
                        .format("jYYYY/jMM/jDD HH:mm");
                }
                return "---";
            },
            header: "تاریخ تحویل",
        },
    ];

    return (
        <>
            <PageHeader
                title="ثبت مرجوعی"
                btnTitle={selectedRefund?.rows?.length ? "ثبت مرجوعی" : false}
                handleClick={async () => {
                    setIsRefundModalOpen(true);
                }}
            />

            <div className="flex justify-between w-full mb-6">
                <div className="flex items-center gap-4">
                    <label className="text-sm font-medium text-gray-700">
                        انتخاب سلر:
                    </label>
                    <select
                        value={selectedSeller?.email || ""}
                        onChange={(e) => {
                            const seller = users.find(user => user.email === e.target.value);
                            setSelectedSeller(seller);
                        }}
                        className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent min-w-[250px]"
                    >
                        <option value="">انتخاب کنید...</option>
                        {users.map((user) => (
                            <option key={user.id} value={user.email}>
                                {user.fullName} ({user.email})
                            </option>
                        ))}
                    </select>
                </div>



            </div>

            <Table
                columns={columns}
                data={data}
                CSVExportPermission="exportRefund"
                tableName="delivered-products"
                isSelective
                setSelected={setSelectedRefund}
            />

            <Modal isOpen={isRefundModalOpen} toggle={() => setIsRefundModalOpen(false)} width={1200}>
                <ModalHeader>
                    ثبت مرجوعی
                </ModalHeader>
                <ModalBody>
                    <div className="p-4">
                        <Inbound isRefund={true} inbound={refundProducts} setInbound={setRefundProducts} />
                        <div className="flex flex-col gap-1 mt-2">
                            <label htmlFor="">توضیحات انباردار</label>
                            <textarea
                                className="rounded-xl p-2 bg-white border border-gray-200"
                                value={warehouserComment + (userComment ? userComment : "")}
                                onChange={(e) => {
                                    setUserComment(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <TwinButton
                        acceptTitle="ثبت مرجوعی"
                        rejectTitle="لغو"
                        rejectHandle={() => {
                            setIsRefundModalOpen(false);
                            setSelectedRefund(null);
                            setWarehouserComment("");
                            setUserComment("");
                            isInitialLoad.current = true;
                        }}
                        acceptHandle={() => {
                            submitRefund();
                            setSelectedRefund(null);
                        }}
                        isCompact
                    />
                </ModalFooter>
            </Modal>
        </>
    )
}
